<template>
  <div>
    <div  class="load" v-if="loadding||noMore">
      <p v-if="loadding">数据拼命加载中
      </p>
      <span v-if="loadding" style="width: 80px;margin-left: 10px;margin-top: -5px;">{{content}}</span>
      <p v-if="noMore&&userInfo.userRole != '0'">没有更多数据了</p>

      <p v-if="userInfo.userRole == '0'">您的VIP功能已过期，继续使用vip功能请重新购买或联系管理员续费升级为VIP会员，服务热线：{{$WebName?'400-150-6806':'18562615223'}}</p>
    </div>

    <div class="emptyData" v-if="total==0&&!loadding&&userInfo.userRole != '0'">
      {{message}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      loadding: {
        type: Boolean
      },
      noMore: {
        type: Boolean
      },
      total: {
        type: Number
      },
      message:{
        type:String,
        default:"未查到任何有关数据"
      }

    },
    data() {
      return {
        content:"。。",
        userInfo: this.$utils.getlocalStorage('userInfo')
      }
    },
    created() {
      console.log(1111)
      let _this = this;
      setInterval(()=>{
        this.content+='。'
        if(this.content.length == 6){
          this.content = '。'
        }
      },500);
    }
}
</script>

<style scoped>
.load{
  width: 1280px;
  margin-top: 10px;
  height: 50px;
  background-color:#ebeef5;
  border-radius: 10px;
  justify-content: center;
  font-size: 18px;
  padding-top: 12px;
  font-weight: 800;
  display: flex;
}
.emptyData{
  width: 1280px;
  height: 300px;
  display: flex;
  font-size: 20px;
  font-weight: 800;
  color: #999999;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;

}
</style>



// WEBPACK FOOTER //
// src/components/loadData.vue